import SortableView from "backbone/shared/views/sortable_view.js"

export default class ProjectsSortView extends SortableView
  events:
    "sortstop"  : "saveSort"

  initialize: ->
    _.extend(SortableView.prototype.events, @events)
    super

  getUrl: ->
    "/portfolio/projects/sort"

  saveSort: ->
    $.ajax
      url: @getUrl()
      data: @$fieldValues.sortable('serialize')
      dataType: "script"
      type: "post"



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/projects_sort_view.js.coffee